import React, { useState } from 'react';
import axios from 'axios';
import ButtonItem from '../components/ButtonItem';
import GenericAutoCompleteInput from '../components/GenericAutoCompleteInput';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus, faSquareMinus } from '@fortawesome/free-solid-svg-icons';
import { GENRES } from '../data/genres';

function AlbumWritePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const page = params.get('page');
  const search = params.get('search');
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';

  const [albumTypeId, setAlbumTypeId] = useState('');
  const [genreId, setGenreId] = useState(null);
  const [feeRate, setFeeRate] = useState('');
  const [nameKr, setNameKr] = useState('');
  const [code, setCode] = useState('');
  const [upc, setUpc] = useState('');
  const [barcode, setBarcode] = useState('');
  const [releaseDateTime, setReleaseDateTime] = useState('');
  const [adultYn, setAdultYn] = useState('');
  const [serviceType, setServiceType] = useState('');
  const [label, setLabel] = useState('');
  const [memo, setMemo] = useState('');
  const [imageUrlInput, setImageUrlInput] = useState(''); // 사용자가 입력한 URL
  const [image, setImage] = useState(
    'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
  ); // 실제 저장된 이미지 경로
  const [clients, setClients] = useState([{ id: -1, feeRate: '', name: '' }]);
  const [artist, setArtist] = useState({ id: null, name: '' });


  // 각 인풋 값 저장
  const feeRateChange = (event) => {
    const inputValue = event.target.value;
    if (/[^0-9]/.test(inputValue)) {
      alert('숫자만 입력할 수 있습니다.');
    }
    setFeeRate(inputValue.replace(/[^0-9]/g, ''));
  };
  const nameKrChange = (event) => setNameKr(event.target.value);
  const codeChange = (event) => setCode(event.target.value);
  const upcChange = (event) => setUpc(event.target.value);
  const barcodeChange = (event) => setBarcode(event.target.value);
  const releaseDateTimeChange = (event) =>
    setReleaseDateTime(event.target.value);
  const adultYnChange = (event) => setAdultYn(event.target.value);
  const serviceTypeChange = (event) => setServiceType(event.target.value);
  const labelChange = (event) => setLabel(event.target.value);
  const memoChange = (event) => setMemo(event.target.value);
  const imageValueChange = async (event) => {
    const url = event.target.value;
    setImageUrlInput(url);

    if (!url) {
      setImage(
        'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
      );
      return;
    }
    // 서버에 이미지 다운로드 요청
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/album/imageDownload`,
        { url }
      );
      setImage(response.data.imagePath);
    } catch {
      setImage(
        'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
      );
    }
  };

  // 등록 버튼
  const add = async () => {
    // 입력값 검사
    if (
      !clients ||
      !artist ||
      !albumTypeId ||
      !genreId ||
      !feeRate ||
      !nameKr ||
      !code ||
      !upc ||
      !releaseDateTime ||
      !adultYn ||
      !serviceType ||
      !label
    ) {
      alert('필수 항목을 빠짐없이 입력해 주세요.');
      return;
    }

    if (confirmFeeRates()) {
      // image가 비어있으면 기본 이미지로 설정
      const imageToSend =
        image && image.trim() !== ''
          ? image
          : 'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg';

      const createAlbumReuqest = {
        clients,
        artistId: artist.id,
        albumTypeId: albumTypeId,
        genreId: genreId,
        feeRate: feeRate,
        nameKr: nameKr,
        code: code,
        upc: upc,
        barcode: barcode,
        releaseDateTime: releaseDateTime,
        adultYn: adultYn,
        serviceType: serviceType,
        label: label,
        memo: memo,
        image: imageToSend,
      };

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/album/`,
          createAlbumReuqest,
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );
        alert('앨범 등록을 완료하였습니다.');
        navigate(`/Albums/${response.data.id}`);
      } catch (error) {
        alert('등록 중 오류가 발생했습니다.');
      }
    }
  };

  // 권리사명 리스트 불러오기 함수
  const fetchClientNames = async (search = '') => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/client/?search=${search}&limit=1000`
    );
    return response.data.items.map((client) => ({
      id: Number(client.id),
      name: client.name,
    }));
  };

  // 아티스트명 리스트 불러오기 함수
  const fetchArtistNames = async (search = '') => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/artist/?search=${search}&limit=1000`
    );
    return response.data.items.map((artist) => ({
      id: Number(artist.id),
      name: artist.nameKr,
    }));
  };

  const addClient = () => {
    const newClient = {
      id: -1,
      feeRate: '',
      name: '',
    };
    setClients([...clients, newClient]);
  };

  const removeClient = (indexToRemove) => {
    const updatedClients = clients.filter(
      (_, index) => index !== indexToRemove
    );
    setClients(updatedClients);
  };

  const confirmFeeRates = () => {
    const total = clients.reduce(
      (sum, client) => sum + Number(client.feeRate || 0),
      0
    );
    if (total !== 100) {
      alert(`분배율의 총합은 100이어야 합니다. 현재 총합: ${total}`);
      return false;
    }
    return true;
  };

  const onChangeClient = (option, index) => {
    const copyClients = [...clients];
    copyClients[index].name = option.name;
    copyClients[index].id = option.id;
    setClients(copyClients);
  };

  const onChangeFeeRate = (e, index) => {
    const value = e.target.value;

    // 빈 값은 허용 (백스페이스 등)
    if (value === '') {
      const copyClients = [...clients];
      copyClients[index].feeRate = '';
      setClients(copyClients);
      return;
    }

    // 숫자가 아니면 alert
    if (!/^\d+$/.test(value)) {
      alert('숫자만 입력해 주세요.');
      return;
    }

    const copyClients = [...clients];
    copyClients[index].feeRate = parseInt(value, 10);
    setClients(copyClients);
  };

  return (
    <>
        <div className="flex mb-8 justify-center items-center">
          <div className="text-xl sm:text-2xl font-bold text-white tracking-tight">
            <span>앨범 등록</span>
          </div>
        </div>

        <div className="space-y-6 max-w-2xl mx-auto">
          {/* 권리사명 */}
          <div>
            <label className="block mb-1">
              <span className="font-semibold">권리사명 </span>
              <span className="text-sm text-slate-400">
                (분배율의 총합은 100이어야 함)
              </span>
            </label>
            {clients.map((client, index) => (
              <div key={client.id} className="flex items-center gap-4 mb-4">
                {/* 권리사명 */}
                <GenericAutoCompleteInput
                  value={client || ''}
                  onChange={onChangeClient}
                  fetchOptions={fetchClientNames}
                  placeholder="권리사를 선택하세요"
                  index={index}
                  clients={clients}
                />
                {/* 수수료율 */}
                <input
                  value={client.feeRate || ''}
                  onChange={(e) => onChangeFeeRate(e, index)}
                  placeholder="분배율 (%)"
                  className="w-28 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                />
                <FontAwesomeIcon
                  icon={faSquarePlus}
                  onClick={index === clients.length - 1 ? addClient : undefined}
                  className={`text-2xl ${
                    index === clients.length - 1
                      ? 'text-sky-500 cursor-pointer'
                      : 'text-gray-300 cursor-not-allowed'
                  }`}
                />
                <FontAwesomeIcon
                  icon={faSquareMinus}
                  onClick={() => removeClient(index)}
                  className="ml-[-0.5rem] text-2xl text-red-400 cursor-pointer"
                />
              </div>
            ))}
          </div>

          {/* 아티스트명 */}
          <div>
            <label className="block font-semibold mb-1">아티스트명</label>
            <GenericAutoCompleteInput
              value={artist || ''}
              onChange={setArtist}
              fetchOptions={fetchArtistNames}
              placeholder="아티스트를 선택하세요"
            />
          </div>

          {/* 앨범 이미지 Url */}
          <div>
            <label className="block font-semibold mb-1">앨범 이미지 Url</label>
            <input
              type="text"
              value={imageUrlInput || ''}
              onChange={imageValueChange}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
              placeholder="이미지 URL을 입력하세요"
            />
            <img
              src={
                image
                  ? image
                  : 'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
              }
              alt={nameKr}
              className="w-[200px] h-[200px] rounded-full object-cover mx-auto shadow mt-2"
              onError={(e) => {
                e.target.onerror = null; // 무한루프 방지
                e.target.src =
                  'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg';
              }}
            />
          </div>

          {/* 앨범명 */}
          <div>
            <label className="block font-semibold mb-1">앨범명</label>
            <input
              type="text"
              value={nameKr || ''}
              onChange={nameKrChange}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
            />
          </div>

          {/* 앨범코드 */}
          <div>
            <label className="block font-semibold mb-1">앨범코드</label>
            <input
              type="text"
              value={code || ''}
              onChange={codeChange}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
            />
          </div>

          {/* UPC */}
          <div>
            <label className="block font-semibold mb-1">UPC</label>
            <input
              type="text"
              value={upc || ''}
              onChange={upcChange}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
            />
          </div>

          {/* 발매일 */}
          <div>
            <label className="block font-semibold mb-1">발매일</label>
            <input
              type="date"
              value={releaseDateTime || ''}
              onChange={releaseDateTimeChange}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
            />
          </div>

          {/* 장르 */}
          <div>
            <label className="block font-semibold mb-1">장르</label>
            <select
              value={genreId}
              onChange={(e) =>
                setGenreId(
                  e.target.value === '' ? null : Number(e.target.value)
                )
              }
              className="w-full px-2 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent">
              <option value="">장르 선택</option>
              {GENRES.map((g) => (
                <option key={g.id} value={g.id}>{g.label}</option>
              ))}
            </select>
          </div>

          {/* 앨범타입 */}
          <div>
            <label className="block font-semibold mb-1">앨범타입</label>
            <div className="flex gap-6">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="albumTypeId"
                  value="싱글"
                  onChange={() => setAlbumTypeId(1)}
                />
                <span>싱글</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="albumTypeId"
                  value="EP"
                  onChange={() => setAlbumTypeId(2)}
                />
                <span>EP</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="albumTypeId"
                  value="정규"
                  onChange={() => setAlbumTypeId(3)}
                />
                <span>정규</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="albumTypeId"
                  value="컴필레이션"
                  onChange={() => setAlbumTypeId(4)}
                />
                <span>컴필레이션</span>
              </label>
            </div>
          </div>

          {/* 19금 */}
          <div>
            <label className="block font-semibold mb-1">19금여부</label>
            <div className="flex gap-6">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="adultYn"
                  value="Y"
                  onChange={adultYnChange}
                />
                <span>19금</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="adultYn"
                  value="N"
                  onChange={adultYnChange}
                />
                <span>전체</span>
              </label>
            </div>
          </div>

          {/* 서비스타입 */}
          <div>
            <label className="block font-semibold mb-1">서비스지역</label>
            <div className="flex gap-6">
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="serviceType"
                  value="전체"
                  onChange={serviceTypeChange}
                />
                <span>전체</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="serviceType"
                  value="국내"
                  onChange={serviceTypeChange}
                />
                <span>국내</span>
              </label>
              <label className="flex items-center gap-1">
                <input
                  type="radio"
                  name="serviceType"
                  value="해외"
                  onChange={serviceTypeChange}
                />
                <span>해외</span>
              </label>
            </div>
          </div>

          {/* 레이블 */}
          <div>
            <label className="block font-semibold mb-1">레이블</label>
            <input
              type="text"
              value={label || ''}
              onChange={labelChange}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
            />
          </div>

          {/* 수수료율 */}
          <div>
            <label className="block font-semibold mb-1">수수료율</label>
            <input
              type="text"
              value={feeRate || ''}
              onChange={feeRateChange}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
            />
          </div>

          {/* 바코드 */}
          <div>
            <label className="block font-semibold mb-1">
              앨범바코드 (선택)
            </label>
            <input
              type="text"
              value={barcode || ''}
              onChange={barcodeChange}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
            />
          </div>

          {/* 메모 */}
          <div>
            <label className="block font-semibold mb-1">메모 (선택)</label>
            <textarea
              rows={5}
              value={memo || ''}
              onChange={memoChange}
              className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-transparent"
            />
          </div>
        </div>

        <div className="w-full flex justify-end items-center mt-5">
          <ButtonItem
            className="mr-2"
            text="목록"
            color="gray"
            onClick={() => navigate(`/Albums?page=${page}${searchParam}`)}
          />
          <ButtonItem text="등록" color="blue" onClick={add} />
        </div>
    </>
  );
}

export default AlbumWritePage;
